import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useRef, useState, } from 'react';
import { getUserData } from './client.js';
export const UserDataContext = createContext(null);
export function UserDataProvider({ children }) {
    // Hack: Prevent useEffect from being called twice in local development
    const hasInitialized = useRef(false);
    const [userData, setUserData] = useState(null);
    useEffect(() => {
        const initializeUserData = () => {
            hasInitialized.current = true;
            getUserData()
                .then((newUserData) => {
                setUserData(newUserData);
            })
                .catch(() => {
                // no-op
            });
        };
        // React.StrictMode intentionally triggers components to render twice in development.
        // This behavior helps detect side effects but also doubles all requests, which can
        // potentially lead to backend throttling issues during development.
        if (!hasInitialized.current) {
            initializeUserData();
        }
    }, []);
    return _jsx(UserDataContext.Provider, { value: userData, children: children });
}
export const useUserData = () => useContext(UserDataContext);
export function withUserDataProvider(WrappedComponent) {
    return function WithUserDataComponent(props) {
        return (_jsx(UserDataProvider, { children: _jsx(WrappedComponent, { ...props }) }));
    };
}
